import {faChevronDown} from '@fortawesome/free-solid-svg-icons';
import {FontAwesomeIcon} from '@fortawesome/react-fontawesome';
import * as React from 'react';
import {FunctionComponent} from 'react';

export interface SelectOption {
    key: any;
    label: string;
}

export interface SelectProps extends React.SelectHTMLAttributes<HTMLSelectElement> {
    children?: any;
    className?: string | undefined;
    id: string;
    htmlFor?: string;
    label?: string;
    onChange: (v: any) => void;
    options: SelectOption[];
}

export const Select: FunctionComponent<SelectProps> = (p) => (
    <React.Fragment>
        <label className="inline-block mb-0 mr-4" htmlFor={p.htmlFor}>
            Assigned to:
        </label>
        <div className="relative">
            <select className={'form-control pr-8 w-full ' + p.className} onChange={(e) => p.onChange(e.target.value)}>
                {p.options.map((o) => (
                    <option key={p.id + o.key} value={o.key}>
                        {o.label}
                    </option>
                ))}
            </select>
            <div className="pointer-events-none absolute inset-y-0 right-0 flex items-center px-2">
                <FontAwesomeIcon className="fill-current ml-4 text-m-gray-6" icon={faChevronDown}/>
            </div>
        </div>
    </React.Fragment>
);
